<template>
  <a :href="source" target="_blank" class="message__image">
    <slot />
    <img v-if="source" class="image" :src="source" alt="message-image" />
    <WIcon v-else icon="icLoad" class="image__loading" size="large" />
  </a>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'

export default {
  components: { WIcon },
  props: {
    source: { type: String, default: undefined }
  }
}
</script>

<style lang="scss">
.message__image {
  max-width: max-content;
  min-height: 56px;
  min-width: 56px;
  overflow: hidden;
  position: relative;

  img {
    max-height: 50vh;
    display: block;
    border-radius: var(--gl-border-radius-md);
  }

  .image__loading {
    animation: spin 1s infinite linear;
    fill: var(--gl-color-shades-white);
    padding: var(--gl-spacing-04);
    position: absolute;
  }
}
</style>
